// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:07:54+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            afade2c873219795095fb5a6c713e81e
//    Signature:      eyJpdiI6Imx1SDVlcEF5SDYzUTlWMDJjOG5aSFE9PSIsInZhbHVlIjoibFI2c2V6ZTZVaWNsMWFLN1JiNGJBMVUrRit3XC8rbkV1cFRJUVpIS21yanBNRENpcVpyaUIwZEFVNzl5SXEyTU1XOGgrZjRwbVdkM3dqZE1jaFpmc3FpclhlRGtsTUQ0NEdlam9WMmJycnltYm1wMFFJVzBIS2pvTm1ZTzk4aThscjdTdDF4VjlzVGVJZGhaZXc0bDdQSmxlSzRhOTFwMGo4Qk9PV0RlOW9JV2VDTDJRODVzWjhvUmJVeWo0M1pDenJYT3hZXC8zMXVaK3BsbFZaMmpUbFM1andJN3JIcEFTeW51bjd3aG5MXC85eEhFekY2cWJtRnI2cTZcL1R4aWhsajFEcitBT1g4YzR6enNSRUxNT29NOGd3N2k3K3l4THlSSHJOMFlYTjRKOWFxRlAxREc5b3JLNHZEQjVSejZxQ2xcL0owSlI2azN1NEduQmNHWGdpek51c0JTWWN6a1NQRHk0enkwdkRBS1pcLzIzNjdORXdFazl0c1pFWW9pVkN4TG9QNW5sMkI0d09VM3U2SllDdXNxSU5Ndz09IiwibWFjIjoiODkzMDFiMDMwNGVkMTVhN2ZmZjZkYTc4ODI4NWU0MGFkMmJhYzk3MDJhYTk0YzdjNWU5YTQ5ZmQ2ZDhhNWIwMCJ9
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
